import { useState } from 'react';
import { useT } from '../../i18n/i18n';
import { addVoluntaryObservationAction } from '../../state/findingStore';
import { Button, Field, SectionEyebrow, SheetShell, TextArea, TextInput, showToast } from '../../ui/components';

// OD-13 / approved draft §3.5: the inspector looked at something New York does not require. What
// they write here is recorded as a VOLUNTARY OBSERVATION — informational, never a defect, never a
// task, printed in the report's own "other observations" block. The observation starts from the
// approved short form ("已看过 · 未见问题") and stays fully editable.
export function VoluntaryObservationSheet(props: { inspectionId: string; areaId: string; onClose: () => void }) {
  const { t } = useT();
  const [title, setTitle] = useState('');
  const [observation, setObservation] = useState(t('finding.voluntaryQuick'));
  const [busy, setBusy] = useState(false);

  async function save() {
    const subject = title.trim();
    const text = observation.trim();
    if (subject.length === 0 || text.length === 0) return;
    setBusy(true);
    try {
      await addVoluntaryObservationAction({ inspectionId: props.inspectionId, areaId: props.areaId, title: subject, observation: text });
      showToast(t('finding.voluntarySaved'));
      props.onClose();
    } finally {
      setBusy(false);
    }
  }

  return (
    <SheetShell
      title={t('finding.voluntaryQuick')}
      onClose={props.onClose}
      testId="voluntary-sheet"
      footer={
        <>
          <Button onClick={() => void save()} disabled={busy || title.trim().length === 0 || observation.trim().length === 0} testId="voluntary-save">
            {t('common.save')}
          </Button>
          <Button variant="text" onClick={props.onClose}>
            {t('shell.cancel')}
          </Button>
        </>
      }
    >
      <p className="card-note">{t('finding.voluntaryHint')}</p>
      <Field label={t('finding.title')} htmlFor="voluntary-title">
        <TextInput id="voluntary-title" value={title} onChange={setTitle} placeholder={t('finding.voluntaryTitlePlaceholder')} testId="voluntary-title" />
      </Field>
      <SectionEyebrow>{t('finding.observation')}</SectionEyebrow>
      <TextArea value={observation} onChange={setObservation} rows={3} testId="voluntary-observation" />
    </SheetShell>
  );
}
